import React from 'react';
import { Helmet } from 'react-helmet';
import AboutNav from '../Components/Navigation/AboutNav';
import Footer from '../Components/Home/Footer';
import SEBISlider from '../Components/Common/SEBISlider';
import ISOCertificateButton from '../Components/Common/ISOCertificateButton';
import { FaExclamationTriangle, FaShieldAlt, FaFileContract, FaHandshake, FaInfoCircle } from 'react-icons/fa';
import '../Assets/Styles/Pages/disclaimer_page.css';

const Disclaimer_page = () => {
  const disclaimerSections = [
    {
      icon: <FaExclamationTriangle />,
      title: "SEBI Registration Disclaimer",
      content: "Registration granted by SEBI, enlistment as RA with exchange and certification from NISM in no way guarantee performance of the Research Analyst or provide any assurance of returns to investors."
    },
    {
      icon: <FaShieldAlt />,
      title: "Securities Illustration",
      content: "The securities quoted, if any are for illustration only and are not recommendatory."
    },
    {
      icon: <FaFileContract />,
      title: "Trading Risk Disclaimer",
      content: "By accessing https://www.trillionstockresearch.com/ website, you have read, understood & agree to be legally bound by the terms of the following disclaimer- Stock trading is inherently risky and you agree to assume complete and full responsibility for the outcomes of all trading decisions that you make, including but not limited to loss of capital."
    },
    {
      icon: <FaInfoCircle />,
      title: "Information Purpose Only",
      content: "Under no circumstances should any person at this site make trading decisions based solely on the information discussed herein. Information and recommendations on the website are for general information only. Nothing contained herein is an advice to sell nor solicitation to buy any securities."
    },
    {
      icon: <FaHandshake />,
      title: "Personal Use Only",
      content: "All information, recommendations, advice and contents shared on the website is meant to be used for personal purpose only and must not be reproduced or copied in any form."
    },
    {
      icon: <FaShieldAlt />,
      title: "Terms Agreement",
      content: "By continuing to use this website, you agree to all our terms and policies."
    }
  ];

  return (
    <>
      <Helmet>
        <title>Disclaimer - Trillion Stock Research | Legal Disclaimers & Risk Warnings</title>
        <meta name="description" content="Important legal disclaimers and risk warnings from Trillion Stock Research. SEBI compliance information, investment risk disclosures, and regulatory compliance details." />
        <meta name="keywords" content="disclaimer, legal disclaimer, investment risks, SEBI compliance, Trillion Stock Research, risk warnings, investment advisory disclaimer" />
        <meta name="author" content="Trillion Stock Research" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.trillionstockresearch.com/disclaimer" />
        
        {/* Open Graph Meta Tags */}
        <meta property="og:title" content="Disclaimer - Trillion Stock Research" />
        <meta property="og:description" content="Legal disclaimers and risk warnings for investment advisory services." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.trillionstockresearch.com/disclaimer" />
        <meta property="og:image" content="https://www.trillionstockresearch.com/fav.png" />
        <meta property="og:site_name" content="Trillion Stock Research" />
        
        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Disclaimer - Trillion Stock Research" />
        <meta name="twitter:description" content="Legal disclaimers and risk warnings for investment advisory services." />
        
        {/* Schema Markup */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Disclaimer",
            "description": "Legal disclaimers and risk warnings for Trillion Stock Research services",
            "url": "https://www.trillionstockresearch.com/disclaimer",
            "isPartOf": {
              "@type": "WebSite",
              "name": "Trillion Stock Research",
              "url": "https://www.trillionstockresearch.com"
            },
            "mainEntity": {
              "@type": "Article",
              "name": "Disclaimer",
              "description": "Legal disclaimers and risk warnings for Trillion Stock Research investment advisory services"
            }
          }
        `}</script>
      </Helmet>
      
      <div className="disclaimer-page">
        <AboutNav />
        <SEBISlider />
        
        <section className="disclaimer-hero">
          <div className="disclaimer-hero-content">
            <h1>Disclaimer</h1>
            <p>Important legal information and disclaimers for our services</p>
          </div>
        </section>

        <section className="disclaimer-container">
          <div className="disclaimer-intro">
            <h2>Legal Disclaimer</h2>
            <p>By accessing <a href="https://www.trillionstockresearch.com/" target="_blank" rel="noopener noreferrer" className="website-link">https://www.trillionstockresearch.com/</a> website, you have read, understood & agree to be legally bound by the terms of the following disclaimer.</p>
          </div>

          <div className="disclaimer-grid">
            {disclaimerSections.map((section, index) => (
              <div key={index} className="disclaimer-card">
                <div className="disclaimer-icon">
                  {section.icon}
                </div>
                <h3>{section.title}</h3>
                <p className="disclaimer-content">{section.content}</p>
              </div>
            ))}
          </div>

          <div className="disclaimer-important">
            <h2>Important Notice</h2>
            <p>This disclaimer is legally binding and constitutes a contract between you and Trillion Stock Research. Please ensure you have read and understood all terms before using our services.</p>
          </div>

          <div className="disclaimer-update">
            <h2>Last Updated</h2>
            <p>This disclaimer is regularly reviewed and updated to ensure compliance with the latest regulations and legal requirements. The last update was made on March 15, 2024.</p>
          </div>
        </section>

        <section className="disclaimer-cta">
          <div className="cta-content">
            <h2>Have Questions About Our Disclaimer?</h2>
            <p>Our legal team is here to help you understand our terms and conditions.</p>
            <button className="cta-button">Contact Legal Support</button>
          </div>
        </section>

        {/* Related Pages Section for SEO */}
        <section className="related-pages">
          <div className="related-pages-container">
            <h2>Related Legal Pages</h2>
            <div className="related-links">
              <a href="/terms" className="related-link">Terms & Conditions</a>
              <a href="/policy" className="related-link">Privacy Policy</a>
              <a href="/refund" className="related-link">Refund Policy</a>
              <a href="/disclosure" className="related-link">SEBI Disclosure</a>
              <a href="/contact" className="related-link">Contact Us</a>
            </div>
          </div>
        </section>

        <Footer />
        <ISOCertificateButton />
      </div>
    </>
  );
};

export default Disclaimer_page;
